import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  header: ".animation--container > *",
  desktopItems:
    ".quick-links__links-container.hide-desktop .animation--item",
  mobileItems:
    ".quick-links__links-container.hide-mobile .animation--item",
  items:
    ".quick-links__links-container:not(.hide-mobile):not(.hide-desktop) .animation--item",
};

export default node => {
  const itemDelay = delayOffset(node, [selectors.header]);

  delayOffset(node, [selectors.desktopItems], itemDelay);
  delayOffset(node, [selectors.mobileItems], itemDelay);
  delayOffset(node, [selectors.items], itemDelay);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
